module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2318752.f925480e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2318752.pdf
// module id = 851
// module chunks = 0